import { B090SokoIdoRequest, catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

export type B090021CreateRequest = {
  idouYmd: string;
  shainCd: string;
  bumonCd: string;
  haraidashilocationCd: string;
  ukeiresokoCd: string;
} & Partial<{ soukoIdouList: B090SokoIdoRequest[] }>;

// 登録処理
export const B090021Create = (props: B090021CreateRequest) => {
  return RestClient.post("b090021/create", props);
};

export type B090021GetRequest = {
  locationCd: string;
  shohinCd: string;
};

export const B090021GetHikiate = (props: B090021GetRequest) => {
  return RestClient.get("b090021/get/hikiate", {
    params: props,
  });
};

//可能数取得処理
export const B090021Kanosu = (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  const meiData = meiMethods.getValues();
  if (meiData.shohinCd === "" || data.haraidashilocationCd === "") {
    meiMethods.setValue("kanosu", "");
    return;
  }
  B090021GetHikiate({
    shohinCd: meiData.shohinCd,
    locationCd: data.haraidashilocationCd,
  })
    .then((response) => {
      meiMethods.setValue("kanosu", response.data.kanosu ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("kanosu", "");
    });
};
